import React, { useState, type FC } from 'react'

import { useRecoilValue } from 'recoil'

import {
  Flex,
  FlexItem,
  SidePanel,
  SidePanelHeader,
} from 'mailup-web-components'

//  import AddDynamicField from 'Pages/RecipientsList/components/columns/AddDynamicField'
import ColumnsList from 'Pages/RecipientsList/components/columns/ColumnsList'
import Info from 'Pages/RecipientsList/components/columns/Info'
import InputColumn from 'Pages/RecipientsList/components/columns/InputColumn'
import PanelConfigColumnsFooter from 'Pages/RecipientsList/components/columns/PanelConfigColumnsFooter'
import PanelConfigColumnsHeader from 'Pages/RecipientsList/components/columns/PanelConfigColumnsHeader'
import Restore from 'Pages/RecipientsList/components/columns/Restore'
import { panelConfigColumnsState } from 'Pages/RecipientsList/recoil/state/configColumns'

const PanelConfigColumns: FC = () => {
  const [y, setY] = useState(0)

  const { show } = useRecoilValue(panelConfigColumnsState)

  return (
    <SidePanel show={show} width="740px" onContentScrollY={setY}>
      <SidePanelHeader padding="16px 32px" showBorder={y > 0}>
        <PanelConfigColumnsHeader />
      </SidePanelHeader>

      <Flex flexDirection="column" height="100%">
        <Flex flexDirection="column" gap="16px" padding="16px 32px 16px 32px">
          <InputColumn />
          {/* <AddDynamicField /> */}
          <Info />
          <Restore />
        </Flex>

        <FlexItem flexGrow="1" padding="0 16px">
          <ColumnsList />
        </FlexItem>

        <PanelConfigColumnsFooter />
      </Flex>
    </SidePanel>
  )
}

export default PanelConfigColumns
